(function(window, angular, undefined) {
    var app = angular.module('formApp');
    app.directive("expandable", [function() {
        return {
            restrict: "A",
            link: function($scope, element, attrs, ctrl) {

                element.on("click", function(e){

                    var buttonlink = this.getAttribute('data-class'),
                        expandBox = document.getElementById(buttonlink),
                        lastFocus;

                    //add class to check if expandable open                    
                    angular.element(expandBox).toggleClass('open');
                    
                    //find focus of last element clicked
                    lastFocus = e.currentTarget;

                    //set focus to expandable region so read out by screen reader
                    if (angular.element(expandBox).hasClass('open')){
                        expandBox.focus();                   
                    } else {
                        lastFocus.focus();
                    }
                   
                    e.preventDefault();
                });     
            }
        };
    }]);
})(window, window.angular);